// extracted by mini-css-extract-plugin
export default {"tooltip":"Xo-z","sharingV2":"Yo-z","sharingIconsV2":"Zo-z","links":"_o-z","link":"ap-z","facebookV2":"bp-z","twitterV2":"cp-z","pinterestV2":"dp-z"};